"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _directBinaryUploadOptions = _interopRequireDefault(require("./direct-binary-upload-options"));

var _constants = require("./constants");

var _uploadError = _interopRequireDefault(require("./upload-error"));

var _errorCodes = _interopRequireDefault(require("./error-codes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Options specific to a file system upload. Also supports all options defined by
 * DirectBinaryUploadOptions.
 */
var FileSystemUploadOptions = /*#__PURE__*/function (_DirectBinaryUploadOp) {
  _inherits(FileSystemUploadOptions, _DirectBinaryUploadOp);

  var _super = _createSuper(FileSystemUploadOptions);

  function FileSystemUploadOptions() {
    var _this;

    _classCallCheck(this, FileSystemUploadOptions);

    _this = _super.call(this);
    _this.replaceValue = '-';

    _this.folderNodeProcessor = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(name) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", name.replace(_constants.RegularExpressions.INVALID_FOLDER_CHARACTERS_REGEX, _this.replaceValue).toLowerCase());

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.assetNodeProcessor = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(name) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", name.replace(_constants.RegularExpressions.INVALID_ASSET_CHARACTERS_REGEX, _this.replaceValue));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }();

    return _this;
  }
  /**
   * Creates a new FileSystemUploadOptions instance that will have the same options
   * as an existing options instance.
   * @param {DirectBinaryUploadOptions} uploadOptions Options whose value should
   *  be copied.
   */


  _createClass(FileSystemUploadOptions, [{
    key: "withMaxUploadFiles",

    /**
     * Sets the maximum number of files that can be uploaded using the module at one time. If
     * the total number of files exceeds this number then the library will throw an exception
     * with code TOO_LARGE.
     * @param {*} maxFileCount 
     * @returns {FileSystemUploadOptions} The current options instance. Allows for chaining.
     */
    value: function withMaxUploadFiles(maxFileCount) {
      this.options.maxUploadFiles = maxFileCount;
      return this;
    }
    /**
     * Sets a value indicating whether or not the process should upload all descendent
     * directories and files within the given directory.
     * @param {boolean} deepUpload True if the upload should be deep, false otherwise.
     * @returns {FileSystemUploadOptions} The current options instance. Allows for chaining.
     */

  }, {
    key: "withDeepUpload",
    value: function withDeepUpload(deepUpload) {
      this.options.deepUpload = deepUpload;
      return this;
    }
    /**
     * Sets a function that will be called before a folder is created in AEM. The given function
     * argument will be given the name of the folder as it appears on the file system, and should
     * return the name to use as the folder's node name in AEM.
     *
     * Regardless of the return value of the processor function, certain illegal characters will
     * always be removed from the node name. These include <code>/\.[]*:|</code>. The characters
     * will be replaced by the value set using withInvalidCharacterReplaceValue().
     *
     * The original folder name will be used as the AEM folder's title.
     *
     * The default behavior is to replace characters <code>%;#,+?^{}"</code> (and whitespace) with the
     * value set using withInvalidCharacterReplaceValue(), and to convert the name to lower case.
     * @param {function} processorFunction Function that will receive a single argument - the
     *  name of a folder. Should return a Promise that resolves with the node name to use for
     *  the folder.
     * @returns {FileSystemUploadOptions} The current options instance. Allows for chaining.
     */

  }, {
    key: "withFolderNodeNameProcessor",
    value: function withFolderNodeNameProcessor(processorFunction) {
      this.folderNodeProcessor = processorFunction;
      return this;
    }
    /**
     * Sets a function that will be called before an asset is created in AEM. The given function
     * argument will be given the name of the asset as it appears on the file system, and should
     * return the name to use as the asset's node name in AEM.
     *
     * Regardless of the return value of the processor function, certain illegal characters will
     * always be removed from the node name. These include <code>/\.[]*:|</code>. The characters
     * will be replaced by the value set using withInvalidCharacterReplaceValue().
     *
     * The default behavior is to replace characters <code>#%{}?&</code> with the
     * value set using withInvalidCharacterReplaceValue().
     * @param {function} processorFunction Function that will receive a single argument - the
     *  name of an asset. Should return a Promise that resolves with the node name to use for
     *  the asset.
     * @returns {FileSystemUploadOptions} The current options instance. Allows for chaining.
     */

  }, {
    key: "withAssetNodeNameProcessor",
    value: function withAssetNodeNameProcessor(processorFunction) {
      this.assetNodeProcessor = processorFunction;
      return this;
    }
    /**
     * The value to use when replacing invalid characters in folder or asset node names.
     * @param {string} replaceValue Value to use when replacing invalid node name characters.
     *  Must not contain any of the invalid characters.
     * @returns {FileSystemUploadOptions} The current options instance. Allows for chaining.
     */

  }, {
    key: "withInvalidCharacterReplaceValue",
    value: function withInvalidCharacterReplaceValue(replaceValue) {
      if (_constants.RegularExpressions.INVALID_CHARACTERS_REGEX.test(replaceValue)) {
        throw new _uploadError.default('Invalid character replace value contains invalid characters', _errorCodes.default.INVALID_OPTIONS);
      }

      this.replaceValue = replaceValue;
      return this;
    }
    /**
     * Upload file options that will be applied to each file that is uploaded as
     * part of the file system upload. Most options that can be passed as part of
     * a single file upload using DirectBinaryUploadOptions.withUploadFiles() are
     * valid. The only exceptions are "fileName", "fileSize", "filePath", and
     * "blob", which will be ignored.
     *
     * @param {object} options Upload file options to apply to each file.
     */

  }, {
    key: "withUploadFileOptions",
    value: function withUploadFileOptions(options) {
      this.uploadFileOptions = options;
      return this;
    }
    /**
     * Retrieves the maximum number of files that the module can upload in a single upload
     * request.
     *
     * @returns {number} Maximum file count.
     */

  }, {
    key: "getMaxUploadFiles",
    value: function getMaxUploadFiles() {
      return this.options.maxUploadFiles || _constants.DefaultValues.MAX_FILE_UPLOAD;
    }
    /**
     * Retrieves a value indicating whether the process should upload all descendent
     * directories and files within the given directory.
     * @returns {boolean} True for a deep upload, false otherwise.
     */

  }, {
    key: "getDeepUpload",
    value: function getDeepUpload() {
      return !!this.options.deepUpload;
    }
    /**
     * Retrieves the function to use to get the node name for a folder to create
     * in AEM.
     * @returns {function} Function that expects a single folder name argument, and
     *  returns a Promise that will be resolved with a node name.
     */

  }, {
    key: "getFolderNodeNameProcessor",
    value: function getFolderNodeNameProcessor() {
      return this.folderNodeProcessor;
    }
    /**
     * Retrieves the function to use to get the node name for an asset to create
     * in AEM.
     * @returns {function} Function that expects a single asset name argument, and
     *  returns a Promise that will be resolved with a node name.
     */

  }, {
    key: "getAssetNodeNameProcessor",
    value: function getAssetNodeNameProcessor() {
      return this.assetNodeProcessor;
    }
    /**
     * Retrieves the value to use when replacing invalid characters in node names.
     * @returns {string} Replace value.
     */

  }, {
    key: "getInvalidCharacterReplaceValue",
    value: function getInvalidCharacterReplaceValue() {
      return this.replaceValue;
    }
    /**
     * Retrieves the upload file options that will be applied to each file uploaded
     * through the module.
     *
     * @returns {object} Upload file options.
     */

  }, {
    key: "getUploadFileOptions",
    value: function getUploadFileOptions() {
      return this.uploadFileOptions || {};
    }
  }], [{
    key: "fromOptions",
    value: function fromOptions(uploadOptions) {
      var newOptions = new FileSystemUploadOptions();
      newOptions.options = _objectSpread({}, uploadOptions.options);
      newOptions.controller = uploadOptions.controller;

      if (typeof uploadOptions.replaceValue === 'string') {
        newOptions.replaceValue = uploadOptions.replaceValue;
      }

      if (typeof uploadOptions.folderNodeProcessor === 'function') {
        newOptions.folderNodeProcessor = uploadOptions.folderNodeProcessor;
      }

      if (typeof uploadOptions.assetNodeProcessor === 'function') {
        newOptions.assetNodeProcessor = uploadOptions.assetNodeProcessor;
      }

      if (_typeof(uploadOptions.uploadFileOptions) === 'object') {
        newOptions.uploadFileOptions = uploadOptions.uploadFileOptions;
      }

      return newOptions;
    }
  }]);

  return FileSystemUploadOptions;
}(_directBinaryUploadOptions.default);

exports.default = FileSystemUploadOptions;